import "./goals.scss";
import HeadlineSection from "../../components/headline-section";
import GoalsCard from "../goals-card";


const Goals = () => {
  return (
      <div className="our-goals">
        <div>
          <HeadlineSection headline="أهداف " secondHeadline="المؤسسة"/>
          <p className="headline-desc">لمؤسسة الشيخ محمد بن صالح الشاوي <br/> مجموعة من الأهداف التي نضعها دائما نصب أعيننا ومن أهمها</p>
        </div>
        
        <div className="all-goals">
            <GoalsCard 
            goalsDesc={"المساهمة في العطاء باحسان للقطاع الخيري بما يحقق وصية الوقف "}
            />
            <GoalsCard 
            goalsDesc={"تطوير ثقافة العمل الخيري لأسرة الشيخ وذريته "}
            />
            <GoalsCard 
            goalsDesc={"بناء عمل مؤسسي متطور "}
            />
        
        </div>
        
      </div>
  );
};

export default Goals;